import { Component, OnInit, Injector, OnDestroy } from '@angular/core';
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { utils } from "src/app/modules/libs/utils";
import { AuthenticationService } from "src/app/services/authentication/authentication.service";
import { Role } from "src/app/components/catalogs/roles/services/role";
import { User } from "src/app/components/catalogs/user-catalog/services/user";
import { AppStateService } from "src/app/store/app-state-service";
import { Servers } from "src/app/common/enumerations/servers-enum";
import { BaseComponent } from "src/app/common/base/base.component";
import { environment } from 'src/environments/environment';
import { LoginDialogService } from 'src/app/services/authentication/login-dialog.service';

@Component({
  selector: "head-login",
  templateUrl: "./head-login.component.html",
  styleUrls: ["./head-login.component.scss"],
})
export class HeadLoginComponent extends BaseComponent implements OnInit, OnDestroy {
  loggedIn = false;

  name!: string | null;
  roles?: string | null;
  rolesList?: (Role | undefined)[] = [];

  logout: boolean = false;
  assSubs: Subscription;

  constructor(
    public login: LoginDialogService,
    private cookieService: CookieService,
    protected override injector: Injector,
    private appState: AppStateService,
    private router: Router
  ) {
    super(injector);
    this.assSubs = this.appState.AppState.subscribe((appState) => {
      this.setUser(appState?.currentUser);
    });
  }

  ngOnInit() {

  }

  override ngOnDestroy(): void {
    this.assSubs?.unsubscribe();
  }

  setUser(user: User | null) {
    this.rolesList = [];
    this.loggedIn = false;
    if (user) {
      user.userRole?.sort((a, b) =>
        utils.sort(a.role?.name ?? '', b.role?.name ?? '', true)
      );
      this.loggedIn = true;
      this.name = user.name ?? '';

      this.rolesList = user.userRole?.map((x) => x.role)
        .sort((a, b) => utils.sort(a?.name ?? '', b?.name ?? '', true));
      this.roles = user.userRole?.map((r) => r.role?.code)
        .sort((a, b) => utils.sort(a ?? '', b ?? '', true))
        .join("/");
    }
  }

  async logOut() {
    if (await this.canDeactivate()) {

      this.name = null;
      this.roles = null;
      this.rolesList = [];
      this.loggedIn = false;
      this.login.logout();

      const el: HTMLElement | null = document.getElementById("userInfo");
      el?.classList.add("hidden");
      localStorage.clear();

      if (document.location.hostname === environment.productionEnvironment) {
        this.cookieService.delete("_shibobj", "/");
        this.alert.warning(
          "You <b>MUST</b> close your browser to complete the logout process."
        );
        this.logout = true;
        const that = this;
        setTimeout(() => {
          this.login.login();
        }, 2000);
      } else {
        // this.login.login();
      }
    }
  }

  showUserInfo() {
    const el: HTMLElement | null = document.getElementById("userInfo");
    if (el?.classList.contains("hidden")) {
      el.classList.remove("hidden");
    } else {
      this.mouseleave();
    }
  }

  override mouseleave() {
    setTimeout(() => {
      const el: HTMLElement | null = document.getElementById("userInfo");
      el?.classList.add("hidden");
    }, 1000);
  }

  userCheck() {
    return (this.currentUser?.id == 18 || this.currentUser?.id == 247) && document.location.hostname === Servers.PRODUCTION;
  }

}
